export const environment = {
  wsSecretKey: 'ADHISH',
  BASE_URL: 'https://stage.dpworks.in/api/v1',
  //   BASE_URL: 'http://localhost:8000/api/v1',
  BASE_URL_V2: 'https://stage.dpworks.in/api/v2',
  WEB_SOCKET: ``,
  DP_PHOTO_SOCKET: `wss://stage.ws.dp.global/photo`,
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
  },
  encryptionKey: '',
  production: true
};